<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Death_In_the_12th_House-5.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-6"><a href="#/OEBPS/Death_In_the_12th_House3#Contents-A">Acknowledgments</a></p>
<p class="fp">To my agent Sandra Bond, with sincere gratitude for all your help and guidance. </p>
<p class="body">To Jessica Tribble, Annette Rogers, Robert Rosenwald, Barbara Peters, and all the wonderful people at Poisoned Pen Press: for your endless aid and support. And to Maryglenn McCombs for your so-appreciated tireless efforts and optimism. </p>
<p class="body">To Fiona Druckenmiller and Roberta Cary, for your unwavering friendship, faith, and stability. </p>
<p class="body">To my dear friends and family who have helped in so many ways: Ray Blumenfeld, Natalie Cagle, Anna Cody, Margaret Dorn, my mother Sidney Lewis, and my bother David Lewis. </p>
<p class="body">And to my brilliant editor and friend Carl Lennertz, whose constant clarity and wisdom continue to amaze me. Two down and many more to go!</p>
<p class="body"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Death_In_the_12th_House-5.vue?4308580c